<template>
  <div class="view-realation">
    <div class="page-relationship">
      <div id="page-relationship" style="height: 500px; width: 100%"></div>
      <div class="page-data">
        <div v-for="item in jumpData" :key="item.id" class="data-item">
          <p class="name">{{ item.name }}</p>
          <p class="value">
            {{ item.value }}
          </p>
        </div>
        <div class="horizontal-line"></div>
        <div class="vertical-line"></div>
      </div>
    </div>
    <div class="page-view">
      <div id="page-view" style="height: 600px; width: 100%"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jumpData: [],
      nodesReal: [],
      linksReal:[],
      
      histogramXAxis:[],
      histogramValue:[],
    };
  },
  props: ["relationshipData"],
  watch: {
    relationshipData: function (newVal, oldVal) {
      // console.log(this.relationshipData);
      this.relationshipData.page.forEach((item) => {
        let color = parseInt(2 * Math.random()) ? "#E35001" : "#FFCA7C";
        this.nodesReal.push({
          id: item.name,
          name: item.name,
          symbolSize: Math.log2(item.value)*2 ,
          value: item.value,
          color:color
        });
        if(this.jumpData.length<4){
          this.jumpData.push({name:item.name,value:item.value})
        }
        if(this.histogramXAxis.length<7){
          this.histogramXAxis.push(item.name)
        }
        if(this.histogramValue.length<7){
          this.histogramValue.push(item.value)
        }
      });
      this.relationshipData.links.forEach((item) => {
   
        this.linksReal.push({
          target: item.target,
          source: item.source,
         
        });
      });
      // console.log(this.linksReal)
       this.creatRelationChart();
       this.createChart();
    },
  },
  // mounted() {
  //   this.createChart();
  // },
  methods: {
    createChart() {
      let that = this;
      var chartDom = document.getElementById("page-view");
      var myChart = this.$echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          borderColor: "transparent",
          borderWidth: "5",
          formatter: function (params) {
            return params[0].name + ": " + params[0].value;
          },
          textStyle: {
            fontSize: "10",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },

        xAxis: {
          data: that.histogramXAxis,
          axisTick: { show: false },
          axisLine: { show: true },
          axisLabel: {
             fontSize: "10",
            color: "#5470C6",
            interval: 0,
            rotate: 30,
          },
        },
        yAxis: {
          offset: 0,
          itemStyle: {
            left: 40,
          },
          splitLine: { show: true },
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: true },
        },
        color: ["#5470C6"],
        series: [
          {
            label: {
              show: true,
              formatter: [
                "{c} ", //引导线上面文字
              ].join("\n"), //用\n来换行
              color: "#434343",
              position: "outside",
            },
            name: "hill",
            type: "pictorialBar",
            barCategoryGap: "-130%",
            // symbol: 'path://M0,10 L10,10 L5,0 L0,10 z',
            symbol:
              "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            itemStyle: {
              opacity: 0.5,
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
              },
            },
            data: that.histogramValue,
            z: 20,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    creatRelationChart() {
      let that = this;
      var chartDom = document.getElementById("page-relationship");
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        // title: {
        //     text: 'Les Miserables',
        //     subtext: 'Circular layout',
        //     top: 'bottom',
        //     left: 'right'
        // },
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",
          // formatter: " {b}用户: {c} ({d}%)",
          // formatter: " {b}: {e}\n",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        //    legend: [{
        //     data: that.categories.map(function (a) {
        //         return a.name;
        //     })
        // }],

        animationDurationUpdate: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
          
            type: "graph",
            layout: "circular",
            circular: {
              rotateLabel: true,
            },
            zoom: 0.6,
            itemStyle: {
              color: function (params) {
                return params.data.color; //获取具体的参数
              },
            },
            label: {
              show: true,
              formatter: "{a|{b} }", //引导线上面文字

              // fontSize: "14",
              // fontWeight: "300",
              // color: "#434343",
              position: "outside",
              //a和b来识别不同的文字区域
              rich: {
                a: {
                  color: "#E35001",
                  left: 30,
                  padding: [0, 10, -20, 10],
                  fontWeight: "300",
                  fontSize: "10",
                },
              },
            },
            data: that.nodesReal,
            links: that.linksReal,
            // roam: true,
            //  categories: that.categories,
            lineStyle: {
              width:0.5,
              color: "source",
              curveness: 0.2,
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang="scss">
.view-realation {
  display: flex;
  .page-view {
    width: 100%;
    float: right;
    margin: 0 auto;
    overflow: visible;
    margin-top: 20px;
  }
  .page-relationship {
    width: 100%;
    float: left;
    margin-top: 20px;
    .page-data {
      .horizontal-line {
        height: 1px;
        width: 60%;
        background: black;
        position: relative;
        margin-left: 20%;
        top: 58px;
      }
      .vertical-line {
        height: 120px;
        width: 1px;
        background: black;
        position: relative;
        margin-left: 50%;
      }
      .data-item:nth-of-type(odd) {
        margin-left: 20%;
      }
      .data-item {
        // border:1px solid black;
        margin-bottom: 30px;
        float: left;
        width: 30%;
        p {
          text-align: center;
        }
        .name {
          font-size: 12px;
        }
        .value {
          font-size: 24px;
          font-weight: bold;
        }
      }
      // width:48%;
      margin: 0 auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/groupPortrait/ViewRelationship.vue